/* Apra — lista de orçamento (favoritos).
   Guarda as pecas no navegador, sem necessidade de conta.
   Ficheiro externo com cache -- antes ia embutido em todas as paginas. */
(function () {
  var CHAVE = 'apra_favoritos';
  var cfg = window.ApraFavoritosConfig || {};
  var EN = !!cfg.en;
  var URL_FAVORITOS = cfg.urlFavoritos || '/pages/favoritos';

  var T = EN ? {
    naLista: 'In your quote list',
    juntar: 'Add to quote list',
    remover: 'Remove',
    vazio: 'You haven\'t added any pieces yet. Browse the catalogue and use the <strong>Add to quote list</strong> button on the pieces you like.',
    textoInicio: 'I would like to request a quote for the following pieces:\n\n'
  } : {
    naLista: 'Na lista de orçamento',
    juntar: 'Juntar ao orçamento',
    remover: 'Remover',
    vazio: 'Ainda não juntou nenhuma peça. Percorra o catálogo e use o botão <strong>Juntar ao orçamento</strong> nas peças que lhe interessarem.',
    textoInicio: 'Gostaria de receber orçamento para as seguintes peças:\n\n'
  };

  function ler() {
    try { return JSON.parse(localStorage.getItem(CHAVE) || '[]'); } catch (e) { return []; }
  }

  function gravar(lista) {
    try { localStorage.setItem(CHAVE, JSON.stringify(lista)); } catch (e) {}
    atualizarContador();
  }

  function dados(el) {
    return {
      handle: el.dataset.handle,
      titulo: el.dataset.titulo,
      url: el.dataset.url,
      img: el.dataset.img,
      tipo: el.dataset.tipo || ''
    };
  }

  function juntar(el) {
    var lista = ler();
    if (!lista.some(function (p) { return p.handle === el.dataset.handle; })) {
      lista.push(dados(el));
      gravar(lista);
    }
  }

  function atualizarContador() {
    var n = ler().length;
    var alvo = document.querySelector('.apra-fav');
    if (!alvo) return;
    var bolha = alvo.querySelector('.apra-contador');
    if (n === 0) { if (bolha) bolha.remove(); return; }
    if (!bolha) {
      bolha = document.createElement('span');
      bolha.className = 'apra-contador';
      alvo.appendChild(bolha);
    }
    bolha.textContent = n;
  }

  function marcarBotao(btn) {
    var dentro = ler().some(function (p) { return p.handle === btn.dataset.handle; });
    btn.dataset.guardado = dentro ? '1' : '0';
    var txt = btn.querySelector('.apra-fav-txt');
    if (txt) txt.textContent = dentro ? T.naLista : T.juntar;
  }

  function ligarBotoes() {
    document.querySelectorAll('.apra-fav-btn').forEach(function (btn) {
      if (btn.dataset.ligado) return;
      btn.dataset.ligado = '1';
      marcarBotao(btn);
      btn.addEventListener('click', function () {
        var lista = ler();
        var i = lista.findIndex(function (p) { return p.handle === btn.dataset.handle; });
        if (i >= 0) lista.splice(i, 1); else lista.push(dados(btn));
        gravar(lista);
        marcarBotao(btn);
      });
    });

    document.querySelectorAll('.apra-fav-ir').forEach(function (btn) {
      if (btn.dataset.ligado) return;
      btn.dataset.ligado = '1';
      btn.addEventListener('click', function () {
        juntar(btn);
        window.location.href = URL_FAVORITOS;
      });
    });
  }

  function desenharLista() {
    var caixa = document.getElementById('apra-favoritos');
    if (!caixa) return;
    var lista = ler();

    if (!lista.length) {
      caixa.innerHTML = '<p class="apra-vazio">' + T.vazio + '</p>';
      preencherFormulario('');
      return;
    }

    var html = '';
    lista.forEach(function (p) {
      html += '<div class="apra-item" data-handle="' + p.handle + '">' +
        '<img src="' + (p.img || '') + '" alt="" loading="lazy">' +
        '<div><a href="' + p.url + '">' + p.titulo + '</a>' +
        (p.tipo ? '<small>' + p.tipo + '</small>' : '') + '</div>' +
        '<button class="apra-remover" type="button">' + T.remover + '</button>' +
        '</div>';
    });
    caixa.innerHTML = html;

    caixa.querySelectorAll('.apra-remover').forEach(function (b) {
      b.addEventListener('click', function () {
        var handle = b.closest('.apra-item').dataset.handle;
        gravar(ler().filter(function (p) { return p.handle !== handle; }));
        desenharLista();
      });
    });

    var texto = T.textoInicio;
    lista.forEach(function (p, i) {
      texto += (i + 1) + '. ' + p.titulo + '\n   ' + location.origin + p.url + '\n';
    });
    texto += '\n';
    preencherFormulario(texto);
  }

  function preencherFormulario(texto) {
    var campo = document.querySelector('form[action*="contact"] textarea');
    if (campo && !campo.dataset.editado) {
      campo.value = texto;
      campo.addEventListener('input', function () { campo.dataset.editado = '1'; }, { once: true });
    }
  }

  function correr() {
    ligarBotoes();
    atualizarContador();
    desenharLista();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', correr);
  } else {
    correr();
  }
  setTimeout(correr, 600);
})();
